import React, { Component } from "react";
import styled from "styled-components";
import _ from "lodash";
import Close from "material-ui/svg-icons/content/clear";
import { connect } from "react-redux";
import { translate } from "react-i18next";

import api from "../../api";
import DashboardEventFeedItem from "./DashboardEventFeedItem";

import AsapRaisedButton from "../../components/AsapRaisedButton";
import AsapAppBar from "../../components/AsapAppBar";
import AsapDrawer from "../../components/AsapDrawer";

class DashboardEventFeed extends Component {
  state = {
    limit: 20,
  };

  componentDidMount() {
    api.loadEventsFeed(this.state.limit);
    api.guestsList();
  }

  handleLoadMore = () => {
    const { limit } = this.state;
    api.loadEventsFeed(limit + 20);
    this.setState({ limit: limit + 20 });
  };

  render() {
    const {
      events, open, isDashboard, onRequestClose, t,
    } = this.props;

    return (
      <AsapDrawer
        onRequestClose={onRequestClose}
        overlay={!isDashboard}
        open={isDashboard || open}
        right
        width={320}
        drawerContainerStyle={{ zIndex: 10001 }}
      >
        <AsapAppBar
          fixed
          content={t("Лента событий")}
          style={{ width: 320 }}
          rightContent={
            <CloseButton onClick={() => onRequestClose()}>
              <Close color="white" />
            </CloseButton>
          }
        />
        <List>{_.map(events, event => <DashboardEventFeedItem event={event} />)}</List>
        <AsapRaisedButton
          label={t("Загрузить ещё")}
          fullWidth
          onClick={this.handleLoadMore}
          style={{ alignSelf: "flex-end" }}
        />
      </AsapDrawer>
    );
  }
}

const mapStateToProps = state => ({
  events: state.dashboard.events,
});

export default connect(mapStateToProps)(translate()(DashboardEventFeed));

const List = styled.div`
  margin-top: 64px;
`;

const CloseButton = styled.div`
  @media (min-width: 1000px) {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardEventFeed.js